import { backboneViewProperties } from "./../../../decorators/backbone-properties";
import { FiltersCollection } from "./../../collections/filters";
import { AdvancedSearchFiltersView } from "./advanced-search-filters";
import { AdvancedSearchFilterModel } from "../../models/advanced-search-filter";
import { AdvancedSearchFilterGroupModel } from "./../../models/advanced-search-filter-group";

const template = require<string>("./advanced-search-filter-group.html");

const dom = {
    SELECT_ALL: ".select-all-filters"
};

@backboneViewProperties({
    template
})
export class AdvancedSearchFilterGroupView extends Marionette.LayoutView<AdvancedSearchFilterGroupModel> {

    public filtersRegion: Marionette.Region;
    public filtersView: AdvancedSearchFiltersView;

    constructor(options?: any) {
        super(options);
        this.setupModelListeners();
    }

    public regions(): any {
        const regions = {
            filtersRegion: ".filters-region"
        };

        return regions;
    }

    public setupModelListeners() {
        this.listenTo(this.model.Filters, "change:Included", this.updateSelectAllButton);
    }

    public onShow() {
        this.setupSubViews();
        this.updateSelectAllButton();
    }

    public setupSubViews() {
        if (!this.filtersView) {
            this.filtersView = new AdvancedSearchFiltersView({collection: this.model.Filters});
        }
        this.filtersRegion.show(this.filtersView);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SELECT_ALL] = (e) => this.selectAllClicked(e);
        return events;
    }

    /**
     * Updates the Select All button to reflect the state of the other boxes in the list -
     * e.g to tick when all other boxes are ticked, and to untick when there is an unticked box in the list
     * @param selectAllBox The "select all" checkbox pertaining to this kind of checkbox - e.g the select all reports, or select all cores buttons
     * @param otherBoxes The other checkboxes of this kind (core or report)
     */
    private updateSelectAllButton(): void {
        const selectAllBox = this.$(".select-all");
        if (!selectAllBox || selectAllBox.length === 0) {
            return;
        }

        const checkboxStates = _.map(this.model.Filters.models, (f) => (f.Enabled && f.Included) || !f.Enabled);
        const areAllTicked = _.reduce(checkboxStates, (memo: boolean, next: boolean) => memo && next, true);

        this.toggleSelectAllButtonText(selectAllBox, areAllTicked);
    }

    private toggleSelectAllButtonText(button: JQuery, allSelected: boolean): void {
        let text = button.parent().children(".label-text").html();
        text = allSelected ? text.replace("Select", "Deselect") : text.replace("Deselect", "Select");
        button.parent().children(".label-text").html(text);
    }

    private selectAllClicked(e: JQueryEventObject) {
        const newState = !this.model.Filters.all((cf: AdvancedSearchFilterModel) => (cf.Enabled && cf.Included) || !cf.Enabled); // If they're all currently true we wanna set em to false
        this.model.Filters.each((f: AdvancedSearchFilterModel) => {
            if (f.SearchWithSubscription) {
                return;
            }
            f.Included = f.Enabled && newState; // if disabled leave disabled
        });
        e.preventDefault();
        return false;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-filter-group.ts